<template>
  <v-chip :color="computedBackgroundColor" class="question-answer-status-chip">
    <QuestionAnswerStatusIcon :status="status" :useTooltip="false" />
    <span class="ml-2">{{ $t(`common.qaStatus.${status}`) }}</span>
  </v-chip>
</template>

<script>
import colors from 'vuetify/util/colors'

import { QA_STATUS } from '@/common/utils/qa-status'

import QuestionAnswerStatusIcon from './QuestionAnswerStatusIcon.vue'

export default {
  name: 'QuestionAnswerStatusChip',
  components: { QuestionAnswerStatusIcon },
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      QA_STATUS,
    }
  },
  computed: {
    computedBackgroundColor () {
      let color
      if (this.status === QA_STATUS.TO_ANSWER) {
        color = colors.orange.base
      }

      if (this.status === QA_STATUS.TO_VALIDATE) {
        color = colors.blue.base
      }

      if (this.status === QA_STATUS.VALIDATED) {
        color = colors.green.base
      }

      return color
    },
  },
}
</script>
